<template>
  <div class="app-success-evn">
    <div class="success-heading"><slot name="heading"><h2>Vielen Dank!</h2></slot></div>
    <div class="before-success-txt"><slot name="txtBefore">Ihre EVN-Einstellungen wurden erfolgreich geändert.</slot></div>
    <div class="current-evn-txt" >{{currentEvn !== undefined ? currentEvn.message : 'Keine Daten'}}</div>
    <Stepper
      :show-next="false"
      @prev="prev"
      :loading-prev="loadingPrev"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Stepper from '../../../generic/Stepper.vue'
import { stepName as prevStep } from './Current.vue'
import processSteps from '@/mixins/processSteps'
import slotProxy from '@/mixins/slotProxy'

export const stepName = 'success'
export default {
  name: 'Success',
  components: { Stepper },
  computed: {
    currentEvn: function () {
      return this.$config.evnMap.find(item => item.key === this.getCurrentEvn())
    }
  },
  mixins: [
    processSteps(prevStep, stepName, stepName),
    slotProxy()
  ],
  methods: {
    ...mapMutations('evn', [
      'changeStep'
    ]),
    ...mapGetters('evn', [
      'getEvnByKey',
      'getCurrentEvn'
    ]),
    async prev () {
      this.loadingPrev = true
      await this.changeStep(prevStep)
      this.loadingPrev = false
    }
  },
  data () {
    return {
      currentEvnConfiguration: {
        evn: ''
      },
      loadingPrev: false
    }
  }
}
</script>
